import { store } from '@/store';

export function clearAllStores() {
  store.commit('authentication/clear');
  store.commit('breadcrumb/clear');
  store.commit('snackbar/clear');
  store.commit('productSearch/clear');
}
